import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { styled } from '@mui/styles';
import { LwButton } from 'redesign';
import { useTranslation } from 'react-i18next';
import { RenderUnsettledUI } from 'shared/components';
import { invariant } from 'shared/utils/utils';
import { PartnerSettingsCard } from './components/partner-settings-card';
import { PartnerPage } from '../partner-page';
import { useGetPartner } from '../../partners/hooks/use-get-partner';
import { useEditPartnerInformation } from '../hooks/use-edit-partner-information';

export const PartnerSettings = () => {
  const { id } = useParams<'id'>();
  invariant(id);
  const partnerQuery = useGetPartner(id);
  const mutation = useEditPartnerInformation(id);
  const { t } = useTranslation(['web-common', 'all-platforms-common']);

  const [isAvailabilityVisible, setIsAvailabilityVisible] = useState<boolean>(false);

  useEffect(() => {
    if (partnerQuery.status === 'success') {
      setIsAvailabilityVisible(partnerQuery.data.isAvailabilityVisible);
    }
  }, [partnerQuery.data?.isAvailabilityVisible]);

  const handleCheckedUpdate = () => {
    mutation.mutate({ isAvailabilityVisible });
  };

  return (
    <PartnerPage>
      <StyledBox>
        <Box display="flex" gap={2}>
          <LwButton color="primary" type="submit" onClick={handleCheckedUpdate}>
            {t('buttons.update', { ns: 'web-common' })}
          </LwButton>
        </Box>
        {partnerQuery.status === 'success' ? (
          <PartnerSettingsCard
            name={t('edit_availability.visibility_title', { ns: 'all-platforms-common' })}
            checked={isAvailabilityVisible}
            disabled={partnerQuery.isLoading}
            onCheckedChange={setIsAvailabilityVisible}
          />
        ) : (
          RenderUnsettledUI({ data: partnerQuery })
        )}
      </StyledBox>
    </PartnerPage>
  );
};

const StyledBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  marginTop: '16px',
  width: '50%',
}));
